import { Icon, Link, useTheme } from "@fluentui/react";
import { AppLinkToExternal } from "global/Application";
import { IFetchOpenRevisionTasksResponse } from "global/DataSources/AppDataSource";
import {
    bcbs_config_release as IXrmTypes_bcbs_config_release,
    bcbs_groupconfigurationsnapshot as IXrmTypes_bcbs_groupconfigurationsnapshot,
    opportunity as IXrmTypes_opportunity
} from "model/CRM";
import { IPicked_bcbs_sbc, Ibcbs_grouplibraryprocess_extended } from "model/CRM.type";

interface IProps {
    snapshot?: Pick<IXrmTypes_bcbs_groupconfigurationsnapshot, 'bcbs_groupconfigurationsnapshotid' | 'bcbs_name' | '_bcbs_groupid_value'>
    opportunity?: IXrmTypes_opportunity
    process?: Ibcbs_grouplibraryprocess_extended,
    revisionTask?: IFetchOpenRevisionTasksResponse,
    sbc?: IPicked_bcbs_sbc,
    bcbs_config_release?: Pick<IXrmTypes_bcbs_config_release, 'bcbs_config_releaseid' | 'bcbs_name'>,
}

const LinkTo = (props: IProps) => {

    const { snapshot, opportunity, process, sbc, revisionTask, bcbs_config_release } = props;

    const theme = useTheme();

    if (opportunity)
        return <>
            <Link
                href={AppLinkToExternal(
                    {
                        type: 'opportunity',
                        id: opportunity.opportunityid!,
                    }
                )}
                target={'_blank'}
            >
                {opportunity.name}
            </Link>
        </>

    if (snapshot)
        return <>
            <Link
                href={AppLinkToExternal(
                    {
                        type: 'bcbs_groupconfigurationsnapshot',
                        id: snapshot.bcbs_groupconfigurationsnapshotid!,
                    }
                )}
                target={'_blank'}
            >
                {snapshot.bcbs_name}
            </Link>
            <Icon
                iconName="PageLink"
                styles={{ root: { fontSize: '12px', paddingLeft: '5px', cursor: 'pointer', color: theme.semanticColors.link } }}
                onClick={() => window.open(AppLinkToExternal({ type: 'groupLibrary', id: [snapshot._bcbs_groupid_value!, snapshot.bcbs_groupconfigurationsnapshotid!] }))}
            />
        </>;

    if (process) {
        return <Link
            href={AppLinkToExternal(
                {
                    type: 'bcbs_grouplibraryprocess',
                    id: process.bcbs_grouplibraryprocessid!,
                }
            )}
            target={'_blank'}
        >
            {process.bcbs_name}
        </Link>
    }

    if (sbc)
        return <Link
            href={AppLinkToExternal(
                {
                    type: 'bcbs_sbc',
                    id: sbc.bcbs_sbcid!,
                }
            )}
            target={'_blank'}
        >
            {sbc.bcbs_name ?? "SBC"}
        </Link>

    if (revisionTask)
        return <Link
            href={AppLinkToExternal(
                {
                    type: 'task',
                    id: revisionTask.activityid!,
                }
            )}
            target={'_blank'}
        >
            {revisionTask.subject ?? "Task"}
        </Link>

    if (bcbs_config_release)
        return <Link
            href={AppLinkToExternal(
                {
                    type: 'bcbs_config_release',
                    id: bcbs_config_release.bcbs_config_releaseid!,
                }
            )}
            target={'_blank'}
        >
            {bcbs_config_release.bcbs_name ?? "Release"}
        </Link>

    return <></>;
}

export default LinkTo;
